import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { type ListCatalogConfigData } from '../business-logic/types/ListCatalogConfigData'
import { getSecondaryCategoryAccessFormDefaults } from '../business-logic/use-cases/getSecondaryCategoryAccessFormDefaults'
import { getUserAccessFormDefaults } from '../business-logic/use-cases/getUserAccessFormDefaults'
import { catalogAccessRepository } from '../data-access/repositories/CatalogAccessRepository'

const base = ['catalog-access']

export const catalogAccessQueryConfig = {
  permissionEnabled: () => ({
    queryKey: buildQueryKey([...base, 'permission-enabled']),
    queryFn: () => catalogAccessRepository.getCatalogPermissionEnabled(),
  }),
  // Called without params, this yields the bare list prefix — `buildQueryKey`
  // stops at the first `undefined` (ADR-5) — which the assign models use for
  // prefix invalidation. `params` is all-optional (`ListCatalogConfigData`).
  userConfigs: (params?: ListCatalogConfigData) => ({
    queryKey: buildQueryKey([...base, 'user-configs', params]),
    queryFn: () => catalogAccessRepository.listUserConfigs(params ?? {}),
  }),
  secondaryCategoryConfigs: (params?: ListCatalogConfigData) => ({
    queryKey: buildQueryKey([...base, 'secondary-category-configs', params]),
    queryFn: () =>
      catalogAccessRepository.listSecondaryCategoryConfigs(params ?? {}),
  }),
  userAccessFormDefaults: () => ({
    queryKey: buildQueryKey([...base, 'user-access-form-defaults']),
    queryFn: getUserAccessFormDefaults,
  }),
  secondaryCategoryAccessFormDefaults: () => ({
    queryKey: buildQueryKey([
      ...base,
      'secondary-category-access-form-defaults',
    ]),
    queryFn: getSecondaryCategoryAccessFormDefaults,
  }),
}
